import { Component, OnInit } from '@angular/core';
import { ModalController,  } from '@ionic/angular';
import { ServiceCategory } from '../../../models';
import { ServiceCategoryService } from '../../../services/service-category.service';
import { List } from 'immutable';
import { ServiceCategoryFormComponent } from '../service-category-form/service-category-form.component';

@Component({
  selector: 'app-service-category-picker',
  templateUrl: './service-category-picker.component.html',
  styleUrls: ['./service-category-picker.component.scss'],
})
export class ServiceCategoryPickerComponent implements OnInit {

  public isLoading: boolean;

  public errorOccurredWhileLoadingServiceCategories: boolean;

  public submitted: boolean;

  public salonServiceCategories: List<ServiceCategory>;

  constructor (private modalCtrl: ModalController,
              private serviceCategoryService: ServiceCategoryService,
              //private viewController: ViewController
              ) {
    this.salonServiceCategories = List([]);
  }

  public ngOnInit () {
    this.loadServiceCategories();
  }

  public onDismiss () {
    this.modalCtrl.dismiss();
  }

  public loadServiceCategories () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingServiceCategories = false;
    this.serviceCategoryService.getSalonServiceCategories()
      .subscribe({
        next:(serviceCategories) => {
        this.salonServiceCategories = serviceCategories;
        this.isLoading = false;
      },
      error: (e) => {
        this.errorOccurredWhileLoadingServiceCategories = true;
        this.isLoading = false;
      }
      });

  }

  public onServiceCategorySelect (serviceCategory: ServiceCategory) {
    this.modalCtrl.dismiss(serviceCategory);
  }

  public async onCreateServiceCategory () {
    const serviceCategoryModal = await this.modalCtrl.create({
      component: ServiceCategoryFormComponent, 
      componentProps: {
      serviceCategory: new ServiceCategory({
        id: undefined,
        categoryName: '',
        serviceDefinitions: List([])
      })
    }
    });

    serviceCategoryModal.onDidDismiss().then((serviceCategory: any) => {

      if (serviceCategory.data) {
        this.salonServiceCategories = this.salonServiceCategories.push(serviceCategory.data);
      }
    });

    return await serviceCategoryModal.present();

  }

}
